var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExteriorpainting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#004c3f",
    "data-name": "15-paint",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61 56h-10v-2h10a1 1 0 0 0 0-2h-10v-2h10a3 3 0 0 1 0 6z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 56h-36a3 3 0 0 1 0-6h36v2h-36a1 1 0 0 0 0 2h36z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 21h2v30h-2z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 25a1 1 0 0 1 -.483-.125l-28.517-15.733-28.517 15.733a1 1 0 0 1 -1.483-.875v-5a1 1 0 0 1 .517-.875l29-16a.994.994 0 0 1 .966 0l29 16a1 1 0 0 1 .517.875v5a1 1 0 0 1 -1 1zm-29-18a1 1 0 0 1 .483.125l27.517 15.181v-2.716l-28-15.448-28 15.448v2.716l27.517-15.181a1 1 0 0 1 .483-.125z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 52h-14a1 1 0 0 1-1-1v-26a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v26a1 1 0 0 1-1 1zm-13-2h12v-24h-12z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 14.59h-2v-9.59a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5.17h-2v-4.17h-6z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 6h-10a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1zm-9-2h8v-2h-8z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 44h-24a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h24a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3zm-24-8a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 51h-2v-2a3 3 0 0 1 3-3h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2v-2h2a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-14a1 1 0 0 0-1 1z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 64a4 4 0 0 1-4-4v-9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v9a4 4 0 0 1-4 4zm-2-12v8a2 2 0 0 0 4 0v-8z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 35h-2v-4a1 1 0 0 0-1-1h-4a1 1 0 0 1-1-1v-7a2 2 0 0 0-4 0v3a3 3 0 0 1-3 3h-2a1 1 0 0 0-1 1v6h-2v-6a3 3 0 0 1 3-3h2a1 1 0 0 0 1-1v-3a4 4 0 0 1 8 0v6h3a3 3 0 0 1 3 3z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55 21h2v11h-2z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 54h6v2h-6z",
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExteriorpainting);
export default __webpack_public_path__ + "static/media/exteriorpainting.f1495f01d0eda25a378f6a4abe6b2c0d.svg";
export { ForwardRef as ReactComponent };